export default __webpack_public_path__ + "static/media/settingsLBIcon.e6e90685.svg";